import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { HelperService } from "../helper.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class CustomInterceptor {

  bypassLoginErrorCodes =
    [
      "OTP_FAILED",
      "OTP_EXPIRED",
      "INVALID_INPUT",
      "INVALID_LINK",
      "VERIFICATION_TOKEN_NOT_FOUND",
    ];

  blockedStatusCode =[
    "02301036",  
    "02301035",
    "02301043"
  ]  
  
  error: any = {
    error: {
      errorCode: 'WENT_WRONG'
    }
  }

  constructor(private router: Router , private helperService : HelperService, private cookieService: CookieService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // next.handle(request).pipe(
    // map((event: HttpEvent<any>) => {
    // })

    const resetPwdToken: string = JSON.parse(sessionStorage.getItem('_RES_PWD_TOKEN'));

    if (request.url !== '/assets/i18n/en.json') {
      let headers = { headers: request.headers.set('verificationtoken', resetPwdToken) }

      if (sessionStorage.getItem('NEW_TOKEN') != null) {
        headers = { headers: request.headers.set('verificationtoken', sessionStorage.getItem('NEW_TOKEN')) }
        sessionStorage.removeItem("NEW_TOKEN");
      }

      request = request.clone(
        headers
      );
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {

          if (event.headers.get("verificationtoken") != null) {
            sessionStorage.setItem("NEW_TOKEN", event.headers.get("verificationtoken"))
          }

          request = request.clone(
            { headers: request.headers.set('verificationtoken', resetPwdToken) }
          );


          if (event.body.status == "FAILED" && this.bypassLoginErrorCodes.indexOf(event.body.errorCode) == -1) {
            sessionStorage.setItem("ErrorCode", event.body.errorCode);
            this.router.navigateByUrl('error', { skipLocationChange: true });
          }
        }
        if(Object.values(this.cookieService.getAll()).length){
          this.removeAllCookies();
        }  
        return event;
      })).pipe(catchError((err: HttpEvent<any>) => {
        if (err instanceof HttpErrorResponse) {
          if(err && err.error && err.error.response && err.error.response.redirectUrl){
            this.helperService.redirectUrl = err.error.response.redirectUrl;
          }
          sessionStorage.setItem("ErrorCode", err.error.errorCode);
          if (err.status === 400 || err.status === 500 || err.status === 401) {
            if(sessionStorage.getItem('APP_SOURCE') == "bass-sca"){
              if(this.blockedStatusCode.includes(err.error?.messages && err.error?.messages[0].code)){
                sessionStorage.setItem("ErrorCode", err.error.messages[0].code);
                this.router.navigateByUrl('error', { skipLocationChange: true });
                return throwError('');
              }
              return throwError(err.error);              
            }else{
              this.router.navigateByUrl('error', { skipLocationChange: true });
            }
          } else {
            if(sessionStorage.getItem('APP_SOURCE') == "bass-sca"){
              return throwError(err.error);              
            }else{
              return throwError(this.error);
            }
          }
        }
        return throwError(this.error);
      }));
  }
  removeAllCookies() {
    this.cookieService.deleteAll('/');
    setTimeout(() => {
      console.log("clear cookie")
      this.cookieService.deleteAll('/');     
  }, 0);
  }
}
